// Generated by ReScript, PLEASE EDIT WITH CARE


function fromUrl(url) {
  var match = url.hash;
  switch (match) {
    case "card-board" :
        return /* CardBoard */4;
    case "horizontal-list" :
        return /* HorizontalList */1;
    case "horizontal-scrollable-container" :
        return /* HorizontalScrollableContainer */3;
    case "nested-vertical-lists" :
        return /* NestedVerticalLists */5;
    case "vertical-list" :
        return /* VerticalList */0;
    case "vertical-scrollable-container" :
        return /* VerticalScrollableContainer */2;
    default:
      return /* VerticalList */0;
  }
}

export {
  fromUrl ,
  
}
/* No side effect */
